<section class="messaging-thread-page">
  <div class="page-actions">
    <button mat-stroked-button type="button" (click)="goBackToInbox()">
      <mat-icon>arrow_back</mat-icon>
      <span>Back To Inbox</span>
    </button>
  </div>

  @if (currentThread$ | async; as thread) {
  <header class="thread-header">
    <div>
      <p class="eyebrow">Thread</p>
      <h1>{{ thread.title || thread.threadType || 'Conversation' }}</h1>
      <!-- <p class="subtitle">Messages are loaded from FHIR Communication using the thread subject, context anchors, and
        participant matching rules.</p> -->
    </div>

    <div class="header-meta">
      @if (thread.lastMessageAt || thread.updatedAt) {
      <span class="meta-pill">
        <mat-icon>schedule</mat-icon>
        {{ (thread.lastMessageAt || thread.updatedAt) | date:'medium' }}
      </span>
      }
      @if (thread.context?.contextType || thread.context?.contextId) {
      <button mat-stroked-button type="button" (click)="openContext(thread)">
        <mat-icon>open_in_new</mat-icon>
        <span>Open {{ thread.context?.contextType || 'Context' }}</span>
      </button>
      }
    </div>
  </header>

  <mat-card class="thread-summary-card">
    <div class="participants-title">
        Participants
      </div>
    <div class="participants-row">
      
      @for (participant of thread.participants ?? []; track participant.participantId) {
      <span class="g-just-flex" style="height: max-content;">
        <mat-icon>person</mat-icon>
        {{ participant.display || participant.participantId }}</span>
      }
    </div>

    @if (thread.context && false) {
    <div class="context-grid">
      @for (entry of (thread.context | keyvalue); track entry.key) {
      @if (entry.value) {
      <div class="context-item">
        <span>{{ entry.key }}</span>
        <strong>{{ entry.value }}</strong>
      </div>
      }
      }
    </div>
    }
  </mat-card>

  <div class="message-layout">
    <section>
      @if (loading$ | async) {
      <div class="loading-state"><mat-spinner diameter="32"></mat-spinner></div>
      } @else {
      @if (messages$ | async; as messages) {
      @if (messages.length) {
      <div class="message-list">
        @for (message of messages; track message.id) {
        <mat-card class="message-card">
          <div class="message-head">
            <div>
              <strong>{{ message.senderDisplay }}</strong>
              <!-- <p>{{ message.senderReference || 'Unknown sender' }}</p> -->
            </div>
            <span>{{ message.sentAt | date:'medium' }}</span>
          </div>

          <mat-divider></mat-divider>

          <div class="message-body">
            <p>{{ message.text }}</p>
          </div>

          <!-- @if (message.recipientReferences.length ) {
          <div class="recipient-row">
            <mat-icon>north_east</mat-icon>
            <span>{{ message.recipientReferences.join(', ') }}</span>
          </div>
          } -->
        </mat-card>
        }
      </div>
      } @else {
      <mat-card class="empty-card">
        <mat-icon>mail</mat-icon>
        <p>No Communication resources matched this thread contract yet.</p>
      </mat-card>
      }

      <mat-card class="reply-composer-card">
        <h2>Reply</h2>
        <mat-form-field appearance="outline" class="reply-field">
          <mat-label>Send a contextual message</mat-label>
          <textarea matInput rows="4" [formControl]="replyControl"
            placeholder="Write a reply to this consultation or request thread."></textarea>
        </mat-form-field>

        @if (sendError$ | async; as sendError) {
        @if (sendError) {
        <p class="send-error">{{ sendError }}</p>
        }
        }

        <div class="reply-actions">
          <button mat-flat-button color="primary" type="button" (click)="sendReply()"
            [disabled]="(sending$ | async) || !hasReplyText()">
            <mat-icon>send</mat-icon>
            <span>Send Reply</span>
          </button>
        </div>
      </mat-card>
      }
      }
    </section>

    <!-- <aside class="contract-panel">
      <mat-card>
        <h2>Matching Contract</h2>
        <p class="contract-subtitle">Frontend rule set used to map a thread to FHIR Communication resources.</p>
        @if (searchRules$ | async; as rules) {
        <ul>
          @for (rule of rules; track rule) {
          <li>{{ rule }}</li>
          }
        </ul>
        }
      </mat-card>
    </aside> -->
  </div>
  } @else {
  <mat-card class="empty-card">
    <mat-icon>forum</mat-icon>
    <p>Select a valid thread to view its Communication messages.</p>
  </mat-card>
  }
</section>